import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation ShiftTemplateDeleteMutation (
  $workspace: ID!,
  $id: ID!
) {
  shiftTemplateDelete (
    workspace: $workspace
    id: $id
  )
}`

async function requestShiftTemplateDelete (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('shift-template-delete', errors)
  }
  return data.shiftTemplateDelete
}

export default requestShiftTemplateDelete
